/**
 * Uniforms library for shared webgl shaders
 */

var UniformsLib = {}

export { UniformsLib }
